import User from './User';
import SetupStatus from './SetupStatus';

class Client {
  set fromJson(json: Map<string, any>) {
    this.id = json['id'];
    this.clientId = json['clientId'];
    this.restaurantName = json['restaurantName'];
    this.projectKey = json['projectKey'];
    this.alreadyExistingClient = json['alreadyExistingClient'];
    this.mangoPayStatementDescriptor = json['mangoPayStatementDescriptor'];
    this.deliveryService = json['deliveryService'];
    this.apiEndpoint = json['apiEndpoint'];
    this.webUrl = json['webUrl'];
    this.deliverySetup = json['deliverySetup'];
    this.clientSetup = json['clientSetup'];
    this.createdAt = json['createdAt'];
    this.updatedAt = json['updatedAt'];
    this.createdBy =
      json['createdBy'] !== undefined
        ? (new User().fromJson = json['createdBy'])
        : undefined;
    this.setupStatus =
      json['setupStatus'] !== undefined
        ? (new SetupStatus().fromJson = json['setupStatus'])
        : undefined;
  }

  get toJson() {
    return {
      id: this.id,
      clientId: this.clientId,
      restaurantName: this.restaurantName,
      projectKey: this.projectKey,
      alreadyExistingClient: this.alreadyExistingClient,
      mangoPayStatementDescriptor: this.mangoPayStatementDescriptor,
      deliveryService: this.deliveryService,
      apiEndpoint: this.apiEndpoint,
      webUrl: this.webUrl,
      deliverySetup: this.deliverySetup,
      clientSetup: this.clientSetup,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      createdBy: this.createdBy?.toJson,
      setupStatus: this.setupStatus?.toJson,
    };
  }

  public id!: number;
  public clientId!: string;
  public restaurantName!: string;
  public projectKey!: string;
  public alreadyExistingClient!: string;
  public mangoPayStatementDescriptor!: string;
  public deliveryService!: string;
  public apiEndpoint!: string;
  public webUrl!: string;
  public deliverySetup!: boolean;
  public clientSetup!: boolean;
  public createdAt!: Date;
  public updatedAt!: Date;
  public createdBy!: User;
  public setupStatus!: SetupStatus;
}

export default Client;
